// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAEue_96sswNIDI_Qks7W8PsMvRMyGiyx8",
  authDomain: "learnerinterface.firebaseapp.com",
  projectId: "learnerinterface",
  storageBucket: "learnerinterface.appspot.com",
  messagingSenderId: "847417094319",
  appId: "1:847417094319:web:758765bd6968fb7d26245a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;